<template>
	<div class="height-100dvh">
		<div class="assess-report-maincont">
			<header
				id="hideinmobile"
				class="cand-header d-flex align-items-center header-bak"
			>
				<img
					@click="$router.go(-1)"
					src="@/assets/img/homepage/back-arrow-blue.svg"
					class="mr-3 pointer"
				/>
				View Reports
			</header>
			<div
				id="hideinlaptop"
				class="mob-back-header d-flex align-items-center justify-content-between"
			>
				<div class="d-flex align-items-center">
					<img
						@click="gobckMobile()"
						class="mr-3"
						src="../../assets/mobile/assprog/mobileBackArrow.svg"
						alt=""
					/>

					<span>View Reports</span>
				</div>
			</div>
			<div class="assrep-below-header">
				<div class="info-section">
					<div class="d-flex gap-3 w-100">
						<div class="dp">
							<img
								v-if="
									candidateInfo &&
									candidateInfo.primaryProfile &&
									candidateInfo.primaryProfile.primaryImage
								"
								class="h-100 w-100 br-50"
								:src="candidateInfo.primaryProfile.primaryImage"
								alt=""
							/>
						</div>
						<div class="flex-1">
							<div class="fam-mont fw-B fs-18 mob-fs-16 text-blue">
								{{ candidateInfo.fullName }}
							</div>
							<div
								id="hideinlaptop"
								class="fam-mont fw-M fs-13 text-3A3C40 mt-1"
							>
								{{ assessmentReport.candidateData.testName }}
							</div>
							<div
								id="hideinmobile"
								class="d-flex justify-content-between mt-3"
							>
								<div class="max-w30">
									<h5 class="fam-lato fs-14 color-595959 fw-R">Test Name :</h5>
									<h4
										class="fam-mont fw-M fs-16 text-434F5E w-100 text-truncate"
									>
										{{ assessmentReport.candidateData.testName }}
									</h4>
								</div>
								<div>
									<h5 class="fam-lato fs-14 color-595959 fw-R">Date & Time:</h5>
									<h4 class="fam-mont fw-M fs-16 text-434F5E">
										{{
											formatDateTime2(
												assessmentReport.candidateData.stats.timing.startTime
											)
										}}
									</h4>
								</div>
								<div>
									<h5 class="fam-lato fs-14 color-595959 fw-R">Time Taken:</h5>
									<h4 class="fam-mont fw-M fs-16 text-434F5E">
										{{
											assessmentReport.candidateData.stats.timing
												? (
														"0" +
														assessmentReport.candidateData.stats.timing.duration.slice(
															0,
															7
														)
												  ).slice(-8) + " (HH:MM:SS)"
												: "--"
										}}
									</h4>
								</div>
								<div>
									<h5 class="fam-lato fs-14 color-595959 fw-R">Attempt No:</h5>
									<h4 class="fam-mont fw-M fs-16 text-434F5E">
										{{ assessmentReport.candidateData.attemptNo }}
									</h4>
								</div>
								<div>
									<h5 class="fam-lato fs-14 color-595959 fw-R">
										Overall Score:
									</h5>
									<h4 class="fam-mont fw-M fs-16 text-434F5E">
										<span class="text-green">{{
											formatScore(
												assessmentReport.candidateData.totalMarksScored
											)
										}}</span>
										/
										{{
											formatScore(
												assessmentReport.candidateData.totalMarksOfTest
											)
										}}
									</h4>
								</div>
								<div>
									<h5 class="fam-lato fs-14 color-595959 fw-R">Result:</h5>
									<h4 class="fam-mont fw-M fs-16">
										<span
											:class="
												assessmentReport.candidateData.result == 'Fail'
													? 'text-red'
													: 'text-green'
											"
										>
											{{
												assessmentReport.candidateData.result == "Fail"
													? "FAIL"
													: "PASS"
											}}</span
										>
									</h4>
								</div>
							</div>
						</div>
					</div>
					<div id="hideinlaptop" class="dashed-div-2"></div>
					<div id="hideinlaptop" class="d-flex justify-content-between mt-3">
						<h5 class="fam-lato fs-14 mob-fs-13 color-595959 fw-R">
							Date & Time:
						</h5>
						<h4 class="fam-mont fw-M fs-16 mob-fs-14 text-434F5E">
							{{
								formatDateTime2(
									assessmentReport.candidateData.stats.timing.startTime
								)
							}}
						</h4>
					</div>
					<div id="hideinlaptop" class="d-flex justify-content-between">
						<h5 class="fam-lato fs-14 mob-fs-13 color-595959 fw-R">
							Time Taken:
						</h5>
						<h4 class="fam-mont fw-M fs-16 mob-fs-14 text-434F5E">
							{{
								assessmentReport.candidateData.stats.timing
									? (
											"0" +
											assessmentReport.candidateData.stats.timing.duration.slice(
												0,
												7
											)
									  ).slice(-8) + " (HH:MM:SS)"
									: "--"
							}}
						</h4>
					</div>
					<div id="hideinlaptop" class="d-flex justify-content-between">
						<h5 class="fam-lato fs-14 mob-fs-13 color-595959 fw-R">
							Attempt No:
						</h5>
						<h4 class="fam-mont fw-M fs-16 mob-fs-14 text-434F5E">
							{{ assessmentReport.candidateData.attemptNo }}
						</h4>
					</div>
					<div id="hideinlaptop" class="d-flex justify-content-between">
						<h5 class="fam-lato fs-14 mob-fs-13 color-595959 fw-R">
							Overall Score:
						</h5>
						<h4 class="fam-mont fw-M fs-16 mob-fs-14 text-434F5E">
							<span class="text-green">{{
								formatScore(assessmentReport.candidateData.totalMarksScored)
							}}</span>
							/
							{{ formatScore(assessmentReport.candidateData.totalMarksOfTest) }}
						</h4>
					</div>
					<div id="hideinlaptop" class="d-flex justify-content-between">
						<h5 class="fam-lato fs-14 mob-fs-13 color-595959 fw-R">Result:</h5>
						<h4 class="fam-mont fw-M fs-16 mob-fs-14">
							<span
								:class="
									assessmentReport.candidateData.result == 'Fail'
										? 'text-red'
										: 'text-green'
								"
							>
								{{
									assessmentReport.candidateData.result == "Fail"
										? "FAIL"
										: "PASS"
								}}</span
							>
						</h4>
					</div>
				</div>

				<div class="tabs-section" :class="{ 'coding-sticky': isCodingSection }">
					<article
						v-for="(section, index) in sections"
						:key="section.sectionID || index"
						:class="selectedSectionIndex === index ? 'selected' : ''"
						@click="selectSection(index), (suspendCollapse = false)"
						:disabled="loadingSection"
						class="pointer"
					>
						{{ section.sectionName || `Section ${index + 1}` }}
					</article>
				</div>

				<div v-if="loadingSection" class="p-3 back-color">
					<!-- Summary Box Shimmer -->
					<div class="summary-box shimmer-container">
						<div
							class="d-flex align-items-center justify-content-between mob-flex-column one"
						>
							<b-skeleton
								class="w-40 h-20"
								style="background: rgba(255, 255, 255, 0.3)"
							></b-skeleton>
							<b-skeleton
								class="w-30 h-20"
								style="background: rgba(255, 255, 255, 0.3)"
							></b-skeleton>
						</div>
						<b-skeleton
							class="w-100 h-15 mt-3"
							style="background: rgba(255, 255, 255, 0.3)"
						></b-skeleton>
						<b-skeleton
							class="w-90 h-15 mt-2"
							style="background: rgba(255, 255, 255, 0.3)"
						></b-skeleton>
						<div class="d-flex align-items-center gap-3 my-3">
							<div class="line"></div>
							<b-skeleton
								class="w-20 h-15"
								style="background: rgba(255, 255, 255, 0.3)"
							></b-skeleton>
							<div class="line"></div>
						</div>
						<div class="d-flex gap-3 ques-hor-scroll">
							<div class="strength shimmer-card">
								<b-skeleton
									class="w-50 h-18 mb-2"
									style="background: rgba(0, 0, 0, 0.1)"
								></b-skeleton>
								<div class="dashed-div-2"></div>
								<b-skeleton
									class="w-100 h-15 mt-2"
									style="background: rgba(0, 0, 0, 0.1)"
								></b-skeleton>
								<b-skeleton
									class="w-90 h-15 mt-2"
									style="background: rgba(0, 0, 0, 0.1)"
								></b-skeleton>
							</div>
							<div class="weakness shimmer-card">
								<b-skeleton
									class="w-50 h-18 mb-2"
									style="background: rgba(0, 0, 0, 0.1)"
								></b-skeleton>
								<div class="dashed-div-2"></div>
								<b-skeleton
									class="w-100 h-15 mt-2"
									style="background: rgba(0, 0, 0, 0.1)"
								></b-skeleton>
								<b-skeleton
									class="w-90 h-15 mt-2"
									style="background: rgba(0, 0, 0, 0.1)"
								></b-skeleton>
							</div>
							<div class="clarification shimmer-card">
								<b-skeleton
									class="w-60 h-18 mb-2"
									style="background: rgba(0, 0, 0, 0.1)"
								></b-skeleton>
								<div class="dashed-div-2"></div>
								<b-skeleton
									class="w-100 h-15 mt-2"
									style="background: rgba(0, 0, 0, 0.1)"
								></b-skeleton>
								<b-skeleton
									class="w-90 h-15 mt-2"
									style="background: rgba(0, 0, 0, 0.1)"
								></b-skeleton>
							</div>
						</div>
					</div>
					<!-- Graph Container Shimmer -->
					<div class="graph-container mt-3">
						<b-skeleton class="w-40 h-20 mb-3"></b-skeleton>
						<div class="dashed-div-2"></div>
						<div
							class="d-flex gap-3 mob-hor-scroll-1"
							:class="{ 'flex-wrap': !isMobile }"
						>
							<div
								v-for="i in 3"
								:key="i"
								class="performance-box calc-wid mt-2 d-flex align-items-center justify-content-center flex-column"
							>
								<b-skeleton class="w-70 h-16"></b-skeleton>
								<b-skeleton class="w-50 h-20 mt-2"></b-skeleton>
								<b-skeleton class="w-80 h-12 mt-1"></b-skeleton>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="p-3 back-color">
					<div class="summary-box">
						<div
							class="d-flex align-items-center justify-content-between mob-flex-column one"
						>
							<div class="fam-mont fw-B fs-16 mob-fs-14 text-white">
								Summary & Feedback
							</div>
							<div
								class="fam-lato fw-R fs-16 mob-fs-14 text-EDEDED d-flex align-items-center gap-3"
							>
								Overall Grade:
								<article
									:class="getOverallGradeClass(currentAiSummary?.overallGrade)"
									class="fam-pop fw-M fs-14 text-white"
								>
									{{ currentAiSummary?.overallGrade || "NA" }}
								</article>
							</div>
						</div>
						<p class="fam-lato fw-R fs-16 mob-fs-14 text-white mt-3">
							{{ currentAiSummary?.sectionSummary || "--" }}
						</p>
						<div class="d-flex align-items-center gap-3 my-3">
							<div class="line"></div>
							<div class="fam-lato fw-R fs-16 mob-fs-14 text-e0e0e0">
								Key Insights
							</div>
							<div class="line"></div>
						</div>
						<div class="d-flex gap-3 ques-hor-scroll" ref="queshorscroll">
							<div class="strength">
								<div
									class="d-flex align-items-center gap-2 fam-mont fw-B fs-18 mob-fs-14 text-green"
								>
									<img
										class="img-1"
										src="../../assets/img/aiInterview/rep-strength.svg"
										alt=""
									/>Strengths
								</div>
								<div class="dashed-div-2"></div>
								<p class="fam-lato fw-R fs-16 mob-fs-14 text-3A3C40 mb-0">
									{{ currentAiSummary?.sectionStrength }}
								</p>
							</div>
							<div class="weakness">
								<div
									class="d-flex align-items-center gap-2 fam-mont fw-B fs-18 mob-fs-14 text-blue"
								>
									<img
										class="img-1"
										src="../../assets/img/aiInterview/rep-weak.svg"
										alt=""
									/>Weakness
								</div>
								<div class="dashed-div-2"></div>
								<p class="fam-lato fw-R fs-16 mob-fs-14 text-3A3C40 mb-0">
									{{ currentAiSummary?.sectionWeakness }}
								</p>
							</div>
							<div class="clarification">
								<div
									class="d-flex align-items-center gap-2 fam-mont fw-B fs-18 mob-fs-16 text-FB923C"
								>
									<img
										class="img-1"
										src="../../assets/img/aiInterview/rep-clar.svg"
										alt=""
									/>Areas of Improvement
								</div>
								<div class="dashed-div-2"></div>
								<p class="fam-lato fw-R fs-16 mob-fs-14 text-3A3C40 mb-0">
									{{ currentAiSummary?.sectionAreasOfImprovement }}
								</p>
							</div>
						</div>
						<div id="hideinlaptop">
							<HorizontalSliderBlog
								v-if="$refs.queshorscroll"
								:scrollContainerRef="$refs.queshorscroll"
								scrollContainerId="scrollContainerqueshorscroll1"
							/>
						</div>
					</div>
					<!-- Sandbox Section -->
					<div v-if="isSandboxSection" class="graph-container">
						<div class="fam-mont fw-B fs-16 text-4A5565 mb-3">
							Sandbox Section Metrics
						</div>
						<div
							v-if="
								currentSectionData &&
								currentSectionData.sectionInfo &&
								currentSectionData.sectionInfo.sandboxResults &&
								currentSectionData.sectionInfo.sandboxResults.SONARQUBE
							"
							class="d-flex align-items-center gap-3 mob-hor-scroll-1"
							:class="{ 'flex-wrap': !isMobile }"
							ref="sandboxscroll"
						>
							<div
								v-for="(metric, index) in currentSectionData.sectionInfo
									.sandboxResults.SONARQUBE"
								:key="index"
								class="performance-box calc-wid mt-2 d-flex align-items-center justify-content-center flex-column"
							>
								<div
									class="fam-mont fw-M fs-16 mob-fs-14 text-4A5565"
									:title="metric.description"
								>
									{{ metric.label }}
								</div>
								<div class="fam-lato fw-B fs-20 mob-fs-18 text-blue mt-2">
									{{ metric.value }}
								</div>
								<div
									class="fam-pop fw-R fs-12 text-464667 mt-1 text-center"
									v-if="metric.description"
								>
									{{ metric.description }}
								</div>
							</div>
						</div>
						<div v-else class="text-center p-3">
							<span class="fam-mont fw-R fs-14 text-4A5565"
								>No Sandbox Metrics Available</span
							>
						</div>
						<div id="hideinlaptop">
							<HorizontalSliderBlog
								v-if="
									currentSectionData.sectionInfo.sandboxResults.SONARQUBE.length
								"
								:scrollContainerRef="$refs.sandboxscroll"
								scrollContainerId="scrollContainersandboxscroll1"
							/>
						</div>
					</div>
					<template
						v-if="
							isCodingSection &&
							currentChildSectionData &&
							currentChildSectionData.sectionInfo
						"
					>
						<div class="d-flex gap-3 mt-4 mob-flex-column">
							<div class="border-box-1 flex-1">
								<div
									class="fam-mont fw-M fs-16 text-4A5565 d-flex align-items-center gap-3"
								>
									Total Questions
								</div>
								<div class="fam-lato fw-B fs-20 text-blue mt-2">
									{{
										currentChildSectionData?.sectionInfo?.sectionResponse
											?.length || 0
									}}
								</div>
							</div>
							<div class="border-box-1 flex-1">
								<div
									class="fam-mont fw-M fs-16 text-4A5565 d-flex align-items-center gap-3"
								>
									Avg. Time Taken Per Question
								</div>
								<div class="fam-lato fw-B fs-20 text-blue mt-2">
									{{
										currentChildSectionData?.sectionInfo?.sectionStats
											?.avgTimePerQuestionSeconds | convertSecToMin
									}}
								</div>
							</div>
							<div class="border-box-1 flex-1">
								<div
									class="fam-mont fw-M fs-16 text-4A5565 d-flex align-items-center gap-3"
								>
									Time Taken On This Section
								</div>
								<div class="fam-lato fw-B fs-20 text-blue mt-2">
									{{
										currentChildSectionData?.sectionInfo?.sectionStats
											?.totalTimeSeconds | convertSecToMin
									}}
								</div>
							</div>
						</div>
						<template v-if="childSections && childSections.length > 0">
							<div class="dashed-div-2 mt-2"></div>
							<div class="tabs-section-2 d-flex">
								<article
									v-for="chSec in childSections"
									:key="chSec.sectionID"
									:class="
										selectedChildSectionID === chSec.sectionID ? 'selected' : ''
									"
									@click="selectChildSection(chSec.sectionID)"
								>
									{{ chSec.sectionName }}
								</article>
							</div>
							<div
								v-for="(question, index) in childSectionQuestions"
								:key="question.questionKey || index"
								class="question-card mt-3"
							>
								<div
									class="d-flex align-items-center gap-4 justify-content-between mob-flex-4 pointer"
									@click="toggleQuestionCollapse(question.questionKey)"
								>
									<div class="flex-1">
										<div class="fam-mont fw-M fs-16 text-darkgrey">
											Q{{ index + 1 }}.
											{{
												question.questionBody?.title ||
												"Question " + (index + 1)
											}}
										</div>
										<div
											class="fam-pop fw-R fs-14 text-464667 mt-1"
											v-if="
												question.questionBody?.actualQuestion ||
												question.questionBody?.question
											"
										>
											{{
												stripHtml(
													question.questionBody?.actualQuestion ||
														question.questionBody?.question
												)
											}}
										</div>
										<div
											class="fam-pop fw-R fs-12 text-464667 mt-1"
											v-if="question.answer?.languagename"
										>
											Language:
											<span class="fw-M text-blue">{{
												question.answer.languagename
											}}</span>
										</div>
									</div>
									<div class="d-flex gap-3 align-items-center">
										<div
											class="green-marks fam-lato fw-B fs-15 text-green px-5"
										>
											{{ parseFloat(question.questionMarks || 0).toFixed(1) }} /
											{{
												parseFloat(question.questionBody?.marks || 0).toFixed(1)
											}}
										</div>
										<img
											id="hideinmobile"
											class="arrow-icon mobrotate0 cursor-pointer"
											:class="
												collapseQuestion[question.questionKey]
													? 'rotated-270'
													: 'rotated-90'
											"
											src="../../assets/newdesign/myprofile/roundRightArrow.svg"
											alt=""
										/>
									</div>
								</div>
								<b-collapse :visible="collapseQuestion[question.questionKey]">
									<div class="dashed-div-2"></div>
									<div class="d-flex align-items-center gap-1 mt-3">
										<img src="../../assets/performance.svg" alt="" />
										Your Performance
									</div>
									<div
										class="d-flex gap-3 mt-3 mob-hor-scroll-1"
										:ref="'performancescroll_' + question.questionKey"
									>
										<div class="performance-box flex-1">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<h4
													class="fam-mont fw-M fs-16 mob-fs-13 text-darkgrey mb-0"
												>
													Correctness
												</h4>
												<h4
													class="fam-lato fw-B fs-20 mob-fs-14 text-blue mb-0"
												>
													{{
														getProgressPercentage(
															question.questionMarks || 0,
															question.questionBody?.marks || 0
														)
													}}%
												</h4>
											</div>
											<div class="dashed-div-2"></div>
											<div>
												<div
													class="d-flex align-items-center fam-mont fs-14 fw-R text-italic text-434f5e mt-3"
												>
													<span>PUBLIC: </span>
													<span class="fw-M text-blue fs-14 ml-1"
														>{{ question.additionalInfo?.visiblePassed || 0 }}
														/
														{{
															question.additionalInfo?.visibleTestCases || 0
														}}</span
													>
												</div>
												<div
													class="d-flex align-items-center fam-mont fs-14 fw-R text-italic text-434f5e mt-2"
												>
													<span>HIDDEN: </span>
													<span class="fw-M text-blue fs-14 ml-1"
														>{{ question.additionalInfo?.hiddenPassed || 0 }}
														/
														{{
															question.additionalInfo?.hiddenTestCases || 0
														}}</span
													>
												</div>
											</div>
										</div>
										<div class="performance-box flex-1">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<h4
													class="fam-mont fw-M fs-16 mob-fs-13 text-darkgrey mb-0"
												>
													Code Quality
												</h4>
												<!-- API returns text description, not score/5 -->
												<h4
													class="fam-lato fw-B fs-20 mob-fs-14 text-blue mb-0"
												>
													{{
														question?.additionalInfo?.codeQualityScore != null
															? `${question.additionalInfo.codeQualityScore}/5`
															: "--"
													}}
												</h4>
											</div>
											<div class="dashed-div-2"></div>
											<div>
												<ul
													class="fam-lato fw-R fs-16 mob-fs-14 text-darkgrey mt-3 mb-0"
												>
													<li>
														{{
															question.additionalInfo?.codeQuality ||
															"No feedback available"
														}}
													</li>
												</ul>
											</div>
										</div>
										<div class="performance-box flex-1">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<h4
													class="fam-mont fw-M fs-16 mob-fs-13 text-darkgrey mb-0"
												>
													Efficiency
												</h4>
												<h4
													class="fam-lato fw-B fs-20 mob-fs-14 text-blue mb-0"
												>
													{{ question.additionalInfo?.efficiency || "--" }}
												</h4>
											</div>
											<div class="dashed-div-2"></div>
											<ul
												class="fam-lato fw-R fs-16 mob-fs-14 text-darkgrey mt-3 mb-0"
											>
												<li>
													Complexity ~
													<span class="text-blue fw-M">{{
														question.additionalInfo?.timeComplexity || "NA"
													}}</span>
												</li>
											</ul>
										</div>
									</div>
									<div id="hideinlaptop">
										<HorizontalSliderBlog
											v-if="collapseQuestion[question.questionKey]"
											:scrollContainerRef="
												getPerformanceScroll(question.questionKey)
											"
											:scrollContainerId="
												'scrollContainerperformancescroll_' +
												question.questionKey
											"
										/>
									</div>
									<div class="d-flex gap-3 mt-3 mob-flex-5">
										<div class="performance-box flex-1">
											<h4
												class="fam-mont fw-M fs-16 mob-fs-13 text-darkgrey mb-0"
											>
												Problem Solving Approach
											</h4>
											<h4
												class="fam-lato fw-B fs-20 mob-fs-14 text-capitalize text-blue mb-0 mt-3"
											>
												{{
													question.additionalInfo?.problemSolvingApproach ||
													"--"
												}}
											</h4>
										</div>
										<div class="performance-box flex-1">
											<h4
												class="fam-mont fw-M fs-16 mob-fs-13 text-darkgrey mb-0"
											>
												Completeness
											</h4>
											<h4
												class="fam-lato fw-B fs-20 mob-fs-14 text-blue mb-0 mt-3"
											>
												{{ question.additionalInfo?.completeness || 0 }}%
											</h4>
										</div>
										<div class="performance-box flex-1">
											<h4
												class="fam-mont fw-M fs-16 mob-fs-13 text-darkgrey mb-0"
											>
												Disallowed Libraries
											</h4>
											<h4
												class="fam-lato fw-B fs-20 mob-fs-14 text-blue mb-0 mt-3"
											>
												No
											</h4>
										</div>
									</div>
								</b-collapse>
								<div
									id="hideinlaptop"
									class="mt-3 w-100 d-flex justify-content-between"
								>
									<span class="fam-mont fw-M fs-14 text-blue mr-2"
										>Hide Detailed Summary</span
									>
									<img
										height="20"
										width="20"
										:class="
											collapseQuestion[question.questionKey]
												? 'rotated-270'
												: 'rotated-90'
										"
										@click="toggleQuestionCollapse(question.questionKey)"
										src="../../assets/newdesign/myprofile/roundRightArrow.svg"
										alt=""
									/>
								</div>
							</div>
						</template>
					</template>
					<!-- Rep-1: Communication Skills Performance Report -->
					<div class="graph-container" id="rep-1" v-if="isCommunicationSection">
						<div class="fam-mont fw-B fs-16 text-4A5565 mob-fs-14">
							Detailed Performance Report
						</div>
						<div class="lined-div"></div>
						<div class="stats-grid">
							<div class="border-box-1 calc-wid mt-2">
								<div class="fam-mont fw-M fs-16 mob-fs-14 text-4A5565">
									Total Questions
								</div>
								<div class="fam-lato fw-B fs-20 mob-fs-18 text-blue mt-2">
									{{ sectionResponse?.length || 0 }}
								</div>
							</div>
							<div class="border-box-1 calc-wid mt-2">
								<div class="fam-mont fw-M fs-16 mob-fs-14 text-4A5565">
									Avg. Time Taken Per Question
								</div>
								<div class="fam-lato fw-B fs-20 mob-fs-18 text-blue mt-2">
									{{
										currentSectionData.sectionInfo.sectionStats
											.avgTimePerQuestionSeconds | convertSecToMin
									}}
								</div>
							</div>
							<div class="border-box-1 calc-wid mt-2">
								<div class="fam-mont fw-M fs-16 mob-fs-14 text-4A5565">
									Time Taken On This Section
								</div>
								<div class="fam-lato fw-B fs-20 mob-fs-18 text-blue mt-2">
									{{
										currentSectionData.sectionInfo.sectionStats.totalTimeSeconds
											| convertSecToMin
									}}
								</div>
							</div>
						</div>
						<div class="dashed-div-2 mt-1"></div>
						<article
							class="attention-box"
							:class="[
								isCommunicationNotAttempted(currentSectionData.sectionInfo)
									? 'bg-matte-7a7a7a border-7a7a7a'
									: currentSectionData.sectionInfo.sectionMarks <=
									  currentSectionData.sectionInfo.serctionTotalMarks / 4
									? 'bg-matte-red border-red'
									: currentSectionData.sectionInfo.sectionMarks <=
									  (currentSectionData.sectionInfo.serctionTotalMarks / 4) * 2
									? 'bg-matte-orange border-orange'
									: currentSectionData.sectionInfo.sectionMarks <=
									  (currentSectionData.sectionInfo.serctionTotalMarks / 4) * 3
									? 'bg-matte-yellow border-yellow'
									: 'bg-matte-green border-green',
							]"
							v-if="
								overallCommunicationScore &&
								!isCommunicationNotAttempted(currentSectionData.sectionInfo)
							"
						>
							<div
								class="green-box fam-mont fw-B fs-20 mob-fs-18 text-white"
								:class="[
									isCommunicationNotAttempted(currentSectionData.sectionInfo)
										? 'bg-7a7a7a'
										: currentSectionData.sectionInfo.sectionMarks <=
										  currentSectionData.sectionInfo.serctionTotalMarks / 4
										? 'bg-red'
										: currentSectionData.sectionInfo.sectionMarks <=
										  (currentSectionData.sectionInfo.serctionTotalMarks / 4) *
												2
										? 'bg-orange'
										: currentSectionData.sectionInfo.sectionMarks <=
										  (currentSectionData.sectionInfo.serctionTotalMarks / 4) *
												3
										? 'bg-yellow'
										: 'bg-green',
								]"
							>
								{{
									isCommunicationNotAttempted(currentSectionData.sectionInfo)
										? "NA"
										: formatSectionMarks(
												currentSectionData.sectionInfo.sectionMarks
										  ) +
										  " / " +
										  currentSectionData.sectionInfo.serctionTotalMarks
								}}
							</div>
							<div class="attention-content">
								<div
									class="fam-mont fw-B fs-16 mob-fs-14"
									:class="[
										isCommunicationNotAttempted(currentSectionData.sectionInfo)
											? 'text-lightgrey'
											: currentSectionData.sectionInfo.sectionMarks <=
											  currentSectionData.sectionInfo.serctionTotalMarks / 4
											? 'color-red-progress'
											: currentSectionData.sectionInfo.sectionMarks <=
											  (currentSectionData.sectionInfo.serctionTotalMarks /
													4) *
													2
											? 'color-orange-progress'
											: currentSectionData.sectionInfo.sectionMarks <=
											  (currentSectionData.sectionInfo.serctionTotalMarks /
													4) *
													3
											? 'color-yellow-progress'
											: 'color-green-progress',
									]"
								>
									<img
										src="../../assets/green-stars.svg"
										v-if="
											!isCommunicationNotAttempted(
												currentSectionData.sectionInfo
											) &&
											currentSectionData.sectionInfo.sectionMarks >
												(currentSectionData.sectionInfo.serctionTotalMarks /
													4) *
													3
										"
										alt=""
									/>
									{{ getCommunicationText(currentSectionData.sectionInfo) }}
								</div>
								<div
									class="fam-mont fw-R fs-15 mob-fs-13 color-2E425D mt-1"
									v-if="overallFeedbacks?.generalFeedback?.overallAssessment"
								>
									{{ overallFeedbacks.generalFeedback.overallAssessment }}
								</div>
							</div>
						</article>

						<div class="candash-player" v-if="overallCommunicationScore">
							<div class="skill-item">
								<div class="skill-header">
									<span class="fam-pop fw-LM fs-14 mob-fs-13 text-464667"
										>Pronunciation</span
									>
									<span
										class="skill-score fam-pop fw-M fs-14 mob-fs-13"
										:class="
											getSkillScoreColor(
												overallCommunicationScore.pronunciationScore?.color
											)
										"
									>
										{{
											overallCommunicationScore.pronunciationScore?.score || 0
										}}/{{ overallCommunicationScore.outOf || 2 }}
									</span>
								</div>
								<b-progress
									:value="
										getProgressPercentage(
											overallCommunicationScore.pronunciationScore?.score,
											overallCommunicationScore.outOf
										)
									"
									:variant="
										getProgressVariant(
											overallCommunicationScore.pronunciationScore?.color
										)
									"
									:class="[
										'mt-1',
										'skill-progress',
										{
											orange:
												overallCommunicationScore.pronunciationScore?.color ===
												'orange',
										},
									]"
								></b-progress>
							</div>
							<div class="skill-item">
								<div class="skill-header">
									<span class="fam-pop fw-LM fs-14 mob-fs-13 text-464667"
										>Fluency</span
									>
									<span
										class="skill-score fam-pop fw-M fs-14 mob-fs-13"
										:class="
											getSkillScoreColor(
												overallCommunicationScore.fluencyScore?.color
											)
										"
									>
										{{ overallCommunicationScore.fluencyScore?.score || 0 }}/{{
											overallCommunicationScore.outOf || 2
										}}
									</span>
								</div>
								<b-progress
									:value="
										getProgressPercentage(
											overallCommunicationScore.fluencyScore?.score,
											overallCommunicationScore.outOf
										)
									"
									:variant="
										getProgressVariant(
											overallCommunicationScore.fluencyScore?.color
										)
									"
									:class="[
										'mt-1',
										'skill-progress',
										{
											orange:
												overallCommunicationScore.fluencyScore?.color ===
												'orange',
										},
									]"
								></b-progress>
							</div>
							<div class="skill-item">
								<div class="skill-header">
									<span class="fam-pop fw-LM fs-14 mob-fs-13 text-464667"
										>Grammar</span
									>
									<span
										class="skill-score fam-pop fw-M fs-14 mob-fs-13"
										:class="
											getSkillScoreColor(
												overallCommunicationScore.grammarScore?.color
											)
										"
									>
										{{ overallCommunicationScore.grammarScore?.score || 0 }}/{{
											overallCommunicationScore.outOf || 2
										}}
									</span>
								</div>
								<b-progress
									:value="
										getProgressPercentage(
											overallCommunicationScore.grammarScore?.score,
											overallCommunicationScore.outOf
										)
									"
									:variant="
										getProgressVariant(
											overallCommunicationScore.grammarScore?.color
										)
									"
									:class="[
										'mt-1',
										'skill-progress',
										{
											orange:
												overallCommunicationScore.grammarScore?.color ===
												'orange',
										},
									]"
								></b-progress>
							</div>
							<div class="skill-item">
								<div class="skill-header">
									<span class="fam-pop fw-LM fs-14 mob-fs-13 text-464667"
										>Vocabulary</span
									>
									<span
										class="skill-score fam-pop fw-M fs-14 mob-fs-13"
										:class="
											getSkillScoreColor(
												overallCommunicationScore.vocabularyScore?.color
											)
										"
									>
										{{
											overallCommunicationScore.vocabularyScore?.score || 0
										}}/{{ overallCommunicationScore.outOf || 2 }}
									</span>
								</div>
								<b-progress
									:value="
										getProgressPercentage(
											overallCommunicationScore.vocabularyScore?.score,
											overallCommunicationScore.outOf
										)
									"
									:variant="
										getProgressVariant(
											overallCommunicationScore.vocabularyScore?.color
										)
									"
									:class="[
										'mt-1',
										'skill-progress',
										{
											orange:
												overallCommunicationScore.vocabularyScore?.color ===
												'orange',
										},
									]"
								></b-progress>
							</div>
							<div class="skill-item">
								<div class="skill-header">
									<span class="fam-pop fw-LM fs-14 mob-fs-13 text-464667"
										>Relevancy to Topic</span
									>
									<span
										class="skill-score fam-pop fw-M fs-14 mob-fs-13"
										:class="
											getSkillScoreColor(
												overallCommunicationScore.relatableScore?.color
											)
										"
									>
										{{
											overallCommunicationScore.relatableScore?.score || 0
										}}/{{ overallCommunicationScore.outOf || 2 }}
									</span>
								</div>
								<b-progress
									:value="
										getProgressPercentage(
											overallCommunicationScore.relatableScore?.score,
											overallCommunicationScore.outOf
										)
									"
									:variant="
										getProgressVariant(
											overallCommunicationScore.relatableScore?.color
										)
									"
									:class="[
										'mt-1',
										'skill-progress',
										{
											orange:
												overallCommunicationScore.relatableScore?.color ===
												'orange',
										},
									]"
								></b-progress>
							</div>
						</div>
						<div class="lined-div mt-3"></div>
						<div
							class="detailed-summary-header mob-flex-column align-items-center"
						>
							<div class="summary-tabs">
								<article
									class="comuni-tabs fam-lato fs-14 mob-fs-12 d-flex gap-1"
								>
									<span class="text-blue fw-M">{{
										sectionResponse?.length || 0
									}}</span>
									<span class="text-tertiary fw-R">Questions</span>
								</article>
								<article
									class="comuni-tabs fam-lato fs-14 mob-fs-12 d-flex gap-1"
								>
									<span class="text-tertiary fw-R">Total Duration: </span>
									<span class="text-blue fw-M">{{
										formatDurationShort(
											communicationSectionInfo?.totalDurationInSec
										)
									}}</span>
								</article>
								<article
									class="comuni-tabs fam-lato fs-14 mob-fs-12 d-flex gap-1"
								>
									<span class="text-tertiary fw-R">Avg WPM: </span>
									<span class="text-blue fw-M">{{
										Math.round(communicationSectionInfo?.avgWpm || 0)
									}}</span>
								</article>
							</div>
							<div
								class="fam-mont fw-M fs-14 mob-fs-12 text-blue cursor-pointer"
								@click="suspendCollapse = !suspendCollapse"
								v-if="!isMobile || !suspendCollapse"
							>
								{{ suspendCollapse ? "Hide" : "Show" }} Detailed Summary
								<img
									class="arrow-icon mobrotate0 mob-16px"
									:class="suspendCollapse ? 'rotated-270' : 'rotated-90'"
									src="../../assets/newdesign/myprofile/roundRightArrow.svg"
									alt=""
								/>
							</div>
						</div>
						<b-collapse :visible="suspendCollapse">
							<div
								v-if="overallFeedbacks?.overallPronunciationFeedback"
								class="detailed-summary-item"
							>
								<div
									class="mob-flex-3"
									@click="toggleMobileSkill('pronunciationScore')"
								>
									<div
										class="fam-mont fw-M fs-14 mob-fs-13 text-4A5565 summary-h-width"
									>
										Pronunciation
									</div>
									<div class="d-flex align-items-center gap-2">
										<div
											class="green-marks fam-lato fw-B fs-15 mob-fs-13"
											:class="
												getScoreColor(
													overallCommunicationScore?.pronunciationScore?.score
												)
											"
										>
											{{
												overallCommunicationScore?.pronunciationScore?.score ||
												0
											}}
											/ {{ overallCommunicationScore?.outOf || 2 }}
										</div>
										<img
											id="hideinlaptop"
											:class="
												mobileSkillCollapse.pronunciationScore
													? 'rotated-275'
													: 'rotated-90'
											"
											src="../../assets/newdesign/myprofile/roundRightArrow.svg"
											alt=""
										/>
									</div>
								</div>
								<b-collapse
									:visible="
										isMobile ? mobileSkillCollapse.pronunciationScore : true
									"
								>
									<div
										class="dashed-div-3 fam-lato fw-R fs-14 mob-fs-12 text-464667"
									>
										{{
											overallFeedbacks.overallPronunciationFeedback
												.commonPatterns
										}}
									</div>
								</b-collapse>
							</div>
							<div
								v-if="overallFeedbacks?.overallFluencyFeedback"
								class="detailed-summary-item"
							>
								<div
									class="mob-flex-3"
									@click="toggleMobileSkill('fluencyScore')"
								>
									<div
										class="fam-mont fw-M fs-14 mob-fs-13 text-4A5565 summary-h-width"
									>
										Fluency
									</div>

									<div class="d-flex align-items-center gap-2">
										<div
											class="green-marks fam-lato fw-B fs-15 mob-fs-13"
											:class="
												getScoreColor(
													overallCommunicationScore?.fluencyScore?.score
												)
											"
										>
											{{ overallCommunicationScore?.fluencyScore?.score || 0 }}
											/
											{{ overallCommunicationScore?.outOf || 2 }}
										</div>
										<img
											id="hideinlaptop"
											:class="
												mobileSkillCollapse.fluencyScore
													? 'rotated-275'
													: 'rotated-90'
											"
											src="../../assets/newdesign/myprofile/roundRightArrow.svg"
											alt=""
										/>
									</div>
								</div>
								<b-collapse
									:visible="isMobile ? mobileSkillCollapse.fluencyScore : true"
								>
									<div
										class="dashed-div-3 fam-lato fw-R fs-14 mob-fs-12 text-464667"
									>
										{{ overallFeedbacks.overallFluencyFeedback.commonPatterns }}
									</div>
								</b-collapse>
							</div>
							<div
								v-if="overallFeedbacks?.overallVocabularyFeedback"
								class="detailed-summary-item"
							>
								<div
									class="mob-flex-3"
									@click="toggleMobileSkill('vocabularyScore')"
								>
									<div
										class="fam-mont fw-M fs-14 mob-fs-13 text-4A5565 summary-h-width"
									>
										Vocabulary
									</div>

									<div class="d-flex align-items-center gap-2">
										<div
											class="green-marks fam-lato fw-B fs-15 mob-fs-13"
											:class="
												getScoreColor(
													overallCommunicationScore?.vocabularyScore?.score
												)
											"
										>
											{{
												overallCommunicationScore?.vocabularyScore?.score || 0
											}}
											/
											{{ overallCommunicationScore?.outOf || 2 }}
										</div>
										<img
											id="hideinlaptop"
											:class="
												mobileSkillCollapse.vocabularyScore
													? 'rotated-275'
													: 'rotated-90'
											"
											src="../../assets/newdesign/myprofile/roundRightArrow.svg"
											alt=""
										/>
									</div>
								</div>
								<b-collapse
									:visible="
										isMobile ? mobileSkillCollapse.vocabularyScore : true
									"
								>
									<div
										class="dashed-div-3 fam-lato fw-R fs-14 mob-fs-12 text-464667"
									>
										{{
											overallFeedbacks.overallVocabularyFeedback.commonPatterns
										}}
									</div>
								</b-collapse>
							</div>
							<div
								v-if="overallFeedbacks?.overallGrammarFeedback"
								class="detailed-summary-item"
							>
								<div
									class="mob-flex-3"
									@click="toggleMobileSkill('grammarScore')"
								>
									<div
										class="fam-mont fw-M fs-14 mob-fs-13 text-4A5565 summary-h-width"
									>
										Grammar
									</div>

									<div class="d-flex align-items-center gap-2">
										<div
											class="green-marks fam-lato fw-B fs-15 mob-fs-13"
											:class="
												getScoreColor(
													overallCommunicationScore?.grammarScore?.score
												)
											"
										>
											{{ overallCommunicationScore?.grammarScore?.score || 0 }}
											/
											{{ overallCommunicationScore?.outOf || 2 }}
										</div>
										<img
											id="hideinlaptop"
											:class="
												mobileSkillCollapse.grammarScore
													? 'rotated-275'
													: 'rotated-90'
											"
											src="../../assets/newdesign/myprofile/roundRightArrow.svg"
											alt=""
										/>
									</div>
								</div>
								<b-collapse
									:visible="isMobile ? mobileSkillCollapse.grammarScore : true"
								>
									<div
										class="dashed-div-3 fam-lato fw-R fs-14 mob-fs-12 text-464667"
									>
										{{ overallFeedbacks.overallGrammarFeedback.commonPatterns }}
									</div>
								</b-collapse>
							</div>
						</b-collapse>
						<div
							id="hideinlaptop"
							class="fam-mont fw-M fs-14 mob-fs-12 text-blue cursor-pointer text-center w-100 mt-2"
							@click="suspendCollapse = !suspendCollapse"
							v-if="suspendCollapse"
						>
							Hide Detailed Summary
							<img
								class="arrow-icon mobrotate0 mob-16px"
								:class="suspendCollapse ? 'rotated-270' : 'rotated-90'"
								src="../../assets/newdesign/myprofile/roundRightArrow.svg"
								alt=""
							/>
						</div>
					</div>
					<!-- Rep-2: Assessment Performance Report -->
					<div
						class="graph-container"
						id="rep-2"
						v-if="isRegularSection && !isSandboxSection"
					>
						<div class="fam-mont fw-B fs-16 mob-fs-14 text-4A5565">
							Detailed Performance Report
						</div>
						<div class="dashed-div-2"></div>
						<div class="rep-2-stats-container">
							<div class="rep-2-stats-left">
								<div class="border-box-1 total-questions-box flex-1">
									<div class="total-questions-wrapper mobile-flex-row">
										<div
											class="total-questions-left align-items-unset d-flex align-items-center gap-2 mob-flex-column"
										>
											<div class="fam-mont fw-M fs-16 mob-fs-14 text-4A5565">
												Total Questions:
											</div>
											<div class="fam-lato fw-B fs-20 mob-fs-18 text-blue">
												{{ answerDistribution?.numberOfQuestions || 0 }}
											</div>
										</div>
										<div class="question-breakdown-horizontal">
											<div>
												<span
													class="fam-mont fw-R fs-14 mob-fs-11 text-434F5E breakdown-label"
													>MCQ:
												</span>
												<span
													class="fam-mont fw-LM fs-16 mob-fs-11 text-blue mob-italic"
												>
													{{ answerDistribution?.mcqCount || 0 }}
												</span>
											</div>
											<div class="vert-line-breakdown"></div>
											<div>
												<span
													class="fam-mont fw-R fs-14 mob-fs-11 text-434F5E breakdown-label"
													>DESCRIPTIVE:
												</span>
												<span
													class="fam-mont fw-LM fs-16 mob-fs-11 mob-italic text-blue"
												>
													{{ answerDistribution?.longCount || 0 }}
												</span>
											</div>
											<div class="vert-line-breakdown"></div>
											<div class="white-space-no-wrap">
												<span
													class="fam-mont fw-R fs-14 mob-fs-11 text-434F5E breakdown-label"
													>MATCH THE FOLLOWING:
												</span>
												<span
													class="fam-mont fw-LM fs-16 mob-fs-11 mob-italic text-blue"
												>
													{{ answerDistribution?.mafoCount || 0 }}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div class="border-box-1 mt-2 flex-1">
									<div class="fam-mont fw-M fs-16 mob-fs-14 text-4A5565">
										Avg. Time Taken Per Question
									</div>
									<div class="fam-lato fw-B fs-20 mob-fs-18 text-blue mt-2">
										{{
											currentSectionData.sectionInfo.sectionStats
												.avgTimePerQuestionSeconds | convertSecToMin
										}}
									</div>
								</div>
								<div class="border-box-1 mt-2 flex-1">
									<div class="fam-mont fw-M fs-16 mob-fs-14 text-4A5565">
										Time Taken On This Section
									</div>
									<div class="fam-lato fw-B fs-20 mob-fs-18 text-blue mt-2">
										{{
											currentSectionData.sectionInfo.sectionStats
												.totalTimeSeconds | convertSecToMin
										}}
									</div>
								</div>
							</div>

							<div class="border-box-1 rep-2-chart-container">
								<div class="d-flex w-100 justify-content-end">
									<div
										id="hideinlaptop"
										class="percent-count-switch"
										:class="{ active: !showAnswerPercentage }"
										@click="showAnswerPercentage = !showAnswerPercentage"
									>
										<div class="switch-track">
											<!-- Icons (background reference only) -->
											<div class="switch-icons">
												<span class="left">%</span>
												<span class="right text-blue fw-B fs-14">123</span>
											</div>

											<!-- Knob -->
											<div
												class="switch-knob d-flex align-items-center justify-content-center"
											>
												<span
													class="knob-text"
													:class="{ active: showAnswerPercentage }"
												>
													{{ showAnswerPercentage ? "%" : "123" }}
												</span>
											</div>
										</div>
									</div>
								</div>

								<!-- Placeholder for Answer Distribution Chart -->
								<!-- Placeholder for Answer Distribution Chart -->
								<div class="chart-placeholder">
									<!-- <div class="chart-label">Answer Distribution</div> -->
									<div
										id="answer-distribution-chart"
										:style="{
											width: '100%',
											height: isMobile ? 'auto' : '300px',
										}"
									></div>
								</div>
							</div>
						</div>
						<template v-if="isRegularSection">
							<div class="dashed-div-2 mt-1"></div>
							<div class="fam-mont fw-B fs-16 mob-fs-14 text-4A5565">
								Performance By Difficulty Level
							</div>
							<!-- Desktop Table View -->
							<div class="performance-table desktop-only mt-3">
								<div class="head mb-2">
									<div class="w-20">
										Difficulty
										<img
											v-if="difficultySortColumn !== 'difficultyLevel'"
											class="pointer"
											src="../../assets/newdesign/transaction/nosort.svg"
											@click="toggleDifficultySort('difficultyLevel')"
										/>
										<img
											v-else-if="difficultySortOrder === 'asc'"
											class="pointer"
											src="../../assets/newdesign/transaction/upsort.svg"
											@click="toggleDifficultySort('difficultyLevel')"
										/>
										<img
											v-else
											class="pointer"
											src="../../assets/newdesign/transaction/downsort.svg"
											@click="toggleDifficultySort('difficultyLevel')"
										/>
									</div>
									<div class="w-20">
										No. of questions
										<img
											v-if="difficultySortColumn !== 'numberOfQuestions'"
											class="pointer"
											src="../../assets/newdesign/transaction/nosort.svg"
											@click="toggleDifficultySort('numberOfQuestions')"
										/>
										<img
											v-else-if="difficultySortOrder === 'asc'"
											class="pointer"
											src="../../assets/newdesign/transaction/upsort.svg"
											@click="toggleDifficultySort('numberOfQuestions')"
										/>
										<img
											v-else
											class="pointer"
											src="../../assets/newdesign/transaction/downsort.svg"
											@click="toggleDifficultySort('numberOfQuestions')"
										/>
									</div>
									<div class="w-15">Correct</div>
									<div class="w-15">Incorrect</div>
									<div class="w-15">Not Answered</div>
									<div class="w-15">%Accuracy</div>
								</div>
								<div class="body">
									<article
										v-for="(item, index) in byDifficultyData"
										:key="item.difficultyLevel || index"
										class="mb-2"
									>
										<div class="blue-bar"></div>
										<div class="w-20 fam-lato fw-R fs-15 text-blue">
											Level
											<span class="fam-lato fw-M fs-16 text-blue">{{
												item.difficultyLevel
											}}</span>
										</div>
										<div class="w-20 fam-lato fw-R fs-15 text-blue">
											{{ item.numberOfQuestions }}
										</div>
										<div class="w-15 fam-mont fw-M fs-15 text-green">
											{{ item.numberOfCorrectAnswers }}
										</div>
										<div class="w-15 fam-mont fw-M fs-15 text-red">
											{{ item.numberOfIncorrectAnswers }}
										</div>
										<div class="w-15 fam-mont fw-M fs-15 text-primary">
											{{ item.numberOfNotAttempted }}
										</div>
										<div class="w-15 fam-mont fw-M fs-15 text-blue">
											{{ item.accuracyPercentage.toFixed(1) }}%
										</div>
									</article>
									<div
										v-if="byDifficultyData.length === 0"
										class="text-center p-3"
									>
										<span class="fam-mont fw-R fs-14 text-4A5565"
											>No data available</span
										>
									</div>
								</div>
							</div>
							<!-- Mobile Card View -->
							<div class="performance-cards mobile-only" id="hideinlaptop">
								<div
									v-for="(item, index) in byDifficultyData"
									:key="item.difficultyLevel || index"
									class="performance-card mt-3"
								>
									<div
										class="performance-card-header"
										@click="toggleDifficultyLevel(item.difficultyLevel)"
									>
										<div class="card-title-section">
											<div class="level-badge">{{ item.difficultyLevel }}</div>
											<span class="fam-mont fw-M fs-16 mob-fs-14 text-4A5565">
												Level {{ item.difficultyLevel }}
											</span>
										</div>
										<div class="card-accuracy-section">
											<span class="fam-mont fw-M fs-14 mob-fs-13 text-blue">
												Accuracy: {{ item.accuracyPercentage.toFixed(1) }}%
											</span>
											<img
												class="arrow-icon-small"
												:class="
													expandedDifficultyLevels[item.difficultyLevel]
														? 'rotated-90'
														: ''
												"
												src="../../assets/newdesign/myprofile/roundRightArrow.svg"
												alt=""
											/>
										</div>
									</div>
									<b-collapse
										:visible="expandedDifficultyLevels[item.difficultyLevel]"
									>
										<div class="performance-card-content">
											<div class="performance-detail-item">
												<span class="fam-mont fw-R fs-14 mob-fs-13 text-4A5565">
													No. of questions:
												</span>
												<span
													class="fam-mont fw-M fs-14 mob-fs-13 text-4A5565"
													>{{ item.numberOfQuestions }}</span
												>
											</div>
											<div class="performance-detail-item">
												<span class="fam-mont fw-R fs-14 mob-fs-13 text-4A5565">
													Correct:
												</span>
												<span
													class="fam-mont fw-M fs-14 mob-fs-13 text-green"
													>{{ item.numberOfCorrectAnswers }}</span
												>
											</div>
											<div class="performance-detail-item">
												<span class="fam-mont fw-R fs-14 mob-fs-13 text-4A5565">
													Incorrect:
												</span>
												<span class="fam-mont fw-M fs-14 mob-fs-13 text-red">{{
													item.numberOfIncorrectAnswers
												}}</span>
											</div>
											<div class="performance-detail-item">
												<span class="fam-mont fw-R fs-14 mob-fs-13 text-4A5565">
													Not Answered:
												</span>
												<span
													class="fam-mont fw-M fs-14 mob-fs-13 text-primary"
													>{{ item.numberOfNotAttempted }}</span
												>
											</div>
										</div>
									</b-collapse>
								</div>
								<div
									v-if="byDifficultyData.length === 0"
									class="text-center p-3"
								>
									<span class="fam-mont fw-R fs-14 text-4A5565"
										>No data available</span
									>
								</div>
							</div>
							<div class="dashed-div-2 mt-1"></div>
							<div class="fam-mont fw-B fs-16 mob-fs-14 text-4A5565">
								Performance By Marks
							</div>
							<!-- Desktop Table View -->
							<div class="performance-table desktop-only mt-3">
								<div class="head mb-2">
									<div class="w-20">
										Marks
										<img
											v-if="marksSortColumn !== 'marksOfeachQuestion'"
											class="pointer"
											src="../../assets/newdesign/transaction/nosort.svg"
											@click="toggleMarksSort('marksOfeachQuestion')"
										/>
										<img
											v-else-if="marksSortOrder === 'asc'"
											class="pointer"
											src="../../assets/newdesign/transaction/upsort.svg"
											@click="toggleMarksSort('marksOfeachQuestion')"
										/>
										<img
											v-else
											class="pointer"
											src="../../assets/newdesign/transaction/downsort.svg"
											@click="toggleMarksSort('marksOfeachQuestion')"
										/>
									</div>
									<div class="w-20">
										No. of questions
										<img
											v-if="marksSortColumn !== 'numberOfQuestions'"
											class="pointer"
											src="../../assets/newdesign/transaction/nosort.svg"
											@click="toggleMarksSort('numberOfQuestions')"
										/>
										<img
											v-else-if="marksSortOrder === 'asc'"
											class="pointer"
											src="../../assets/newdesign/transaction/upsort.svg"
											@click="toggleMarksSort('numberOfQuestions')"
										/>
										<img
											v-else
											class="pointer"
											src="../../assets/newdesign/transaction/downsort.svg"
											@click="toggleMarksSort('numberOfQuestions')"
										/>
									</div>
									<div class="w-15">Correct</div>
									<div class="w-15">Incorrect</div>
									<div class="w-15">Not Answered</div>
									<div class="w-15">%Accuracy</div>
								</div>
								<div class="body">
									<article
										v-for="(item, index) in byMarksData"
										:key="item.marksOfeachQuestion || index"
										class="mb-2"
									>
										<div class="blue-bar"></div>
										<div class="w-20 fam-lato fw-R fs-15 text-blue">
											<span class="fam-lato fw-M fs-16 text-blue">{{
												item.marksOfeachQuestion
											}}</span>
											Mark
										</div>
										<div class="w-20 fam-lato fw-R fs-15 text-blue">
											{{ item.numberOfQuestions }}
										</div>
										<div class="w-15 fam-mont fw-M fs-15 text-green">
											{{ item.numberOfCorrectAnswers }}
										</div>
										<div class="w-15 fam-mont fw-M fs-15 text-red">
											{{ item.numberOfIncorrectAnswers }}
										</div>
										<div class="w-15 fam-mont fw-M fs-15 text-primary">
											{{ item.numberOfNotAttempted }}
										</div>
										<div class="w-15 fam-mont fw-M fs-15 text-blue">
											{{ item.accuracyPercentage.toFixed(1) }}%
										</div>
									</article>
									<div v-if="byMarksData.length === 0" class="text-center p-3">
										<span class="fam-mont fw-R fs-14 text-4A5565"
											>No data available</span
										>
									</div>
								</div>
							</div>
							<!-- Mobile Card View -->
							<div class="performance-cards mobile-only" id="hideinlaptop">
								<div
									v-for="(item, index) in byMarksData"
									:key="item.marksOfeachQuestion || index"
									class="performance-card mt-3"
								>
									<div
										class="performance-card-header"
										@click="toggleMarksLevel(item.marksOfeachQuestion)"
									>
										<div class="card-title-section">
											<div class="level-badge">
												{{ parseFloat(item.marksOfeachQuestion).toFixed(0) }}
											</div>
											<span class="fam-mont fw-M fs-16 mob-fs-14 text-4A5565">
												{{ item.marksOfeachQuestion }} Mark
											</span>
										</div>
										<div class="card-accuracy-section">
											<span class="fam-mont fw-M fs-14 mob-fs-13 text-blue">
												Accuracy: {{ item.accuracyPercentage.toFixed(1) }}%
											</span>
											<img
												class="arrow-icon-small"
												:class="
													expandedMarksLevels[item.marksOfeachQuestion]
														? 'rotated-90'
														: ''
												"
												src="../../assets/newdesign/myprofile/roundRightArrow.svg"
												alt=""
											/>
										</div>
									</div>
									<b-collapse
										:visible="expandedMarksLevels[item.marksOfeachQuestion]"
									>
										<div class="performance-card-content">
											<div class="performance-detail-item">
												<span class="fam-mont fw-R fs-14 mob-fs-13 text-4A5565">
													No. of questions:
												</span>
												<span
													class="fam-mont fw-M fs-14 mob-fs-13 text-4A5565"
													>{{ item.numberOfQuestions }}</span
												>
											</div>
											<div class="performance-detail-item">
												<span class="fam-mont fw-R fs-14 mob-fs-13 text-4A5565">
													Correct:
												</span>
												<span
													class="fam-mont fw-M fs-14 mob-fs-13 text-green"
													>{{ item.numberOfCorrectAnswers }}</span
												>
											</div>
											<div class="performance-detail-item">
												<span class="fam-mont fw-R fs-14 mob-fs-13 text-4A5565">
													Incorrect:
												</span>
												<span class="fam-mont fw-M fs-14 mob-fs-13 text-red">{{
													item.numberOfIncorrectAnswers
												}}</span>
											</div>
											<div class="performance-detail-item">
												<span class="fam-mont fw-R fs-14 mob-fs-13 text-4A5565">
													Not Answered:
												</span>
												<span
													class="fam-mont fw-M fs-14 mob-fs-13 text-primary"
													>{{ item.numberOfNotAttempted }}</span
												>
											</div>
										</div>
									</b-collapse>
								</div>
								<div v-if="byMarksData.length === 0" class="text-center p-3">
									<span class="fam-mont fw-R fs-14 text-4A5565"
										>No data available</span
									>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getAssessmentReport } from "@/utils/apiFunctions";
import HorizontalSliderBlog from "../../components/fixedcomponents/HorizontalScroll.vue";
import { AnswerDistributionDonut } from "./AnswerDistributionDonut";
import { mapGetters } from "vuex";
export default {
	data() {
		return {
			showAnswerPercentage: false,
			suspendCollapse: false,
			collapseQuestion: {},
			assessmentReport: null,
			selectedSectionIndex: 0,
			selectedChildSectionID: null,
			sectionData: {}, // Store section-specific data keyed by sectionID
			loadingSection: false,
			expandedDifficultyLevels: {},
			expandedMarksLevels: {},
			difficultySortColumn: null,
			difficultySortOrder: null,
			marksSortColumn: null,
			marksSortOrder: null,
			mobileSkillCollapse: {},
			donutGraph: new AnswerDistributionDonut(),
		};
	},
	computed: {
		sonarQubeResults() {
			return (
				this.currentSectionData?.sectionInfo?.sandboxResults?.SONARQUBE || []
			);
		},
		isSandboxSection() {
			return this.currentSection && this.currentSection.sandboxSection === true;
		},
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
		isMobile() {
			return window.innerWidth <= 1028;
		},
		currentAiSummary() {
			// Check if assessmentReport and its nested properties exist
			if (!this.assessmentReport || !this.assessmentReport.candidateData) {
				return null;
			}

			const summaries = this.assessmentReport.candidateData.stats?.aiSummary;

			// Ensure summaries is an array and currentSection exists
			if (!Array.isArray(summaries) || summaries.length === 0) {
				return null;
			}

			if (!this.currentSection || !this.currentSection.sectionID) {
				return null;
			}

			// Match summary by sectionID
			const matchedSummary = summaries.find(
				(item) => item.sectionID === this.currentSection.sectionID
			);

			// Return matched summary or first one as fallback
			return matchedSummary || summaries[0];
		},
		sections() {
			if (
				this.assessmentReport &&
				this.assessmentReport.candidateData &&
				this.assessmentReport.candidateData.sections
			) {
				return this.assessmentReport.candidateData.sections;
			}
			return [];
		},
		currentSection() {
			if (
				this.sections.length > 0 &&
				this.selectedSectionIndex >= 0 &&
				this.selectedSectionIndex < this.sections.length
			) {
				return this.sections[this.selectedSectionIndex];
			}
			return null;
		},
		currentSectionData() {
			if (
				this.currentSection &&
				this.sectionData[this.currentSection.sectionID]
			) {
				return this.sectionData[this.currentSection.sectionID];
			}
			return null;
		},
		// Helper computed properties for section data
		sectionStats() {
			if (this.currentSectionData && this.currentSectionData.candidateData) {
				return this.currentSectionData.candidateData;
			}
			return null;
		},
		// Get difficulty level data
		byDifficultyData() {
			if (!this.currentSectionData?.sectionInfo?.byDifficulty) return [];

			let data = [...this.currentSectionData.sectionInfo.byDifficulty];

			if (!this.difficultySortColumn) return data;

			return [...this.currentSectionData.sectionInfo.byDifficulty].sort(
				(a, b) =>
					this.difficultySortOrder === "asc"
						? a[this.difficultySortColumn] - b[this.difficultySortColumn]
						: b[this.difficultySortColumn] - a[this.difficultySortColumn]
			);
		},

		// Get marks data
		byMarksData() {
			if (!this.currentSectionData?.sectionInfo?.byMarks) return [];

			let data = [...this.currentSectionData.sectionInfo.byMarks];

			if (!this.marksSortColumn) return data;

			return [...this.currentSectionData.sectionInfo.byMarks].sort((a, b) =>
				this.marksSortOrder === "asc"
					? a[this.marksSortColumn] - b[this.marksSortColumn]
					: b[this.marksSortColumn] - a[this.marksSortColumn]
			);
		},

		// Get answer distribution data
		answerDistribution() {
			if (
				this.currentSectionData &&
				this.currentSectionData.sectionInfo &&
				this.currentSectionData.sectionInfo.answerDistribution
			) {
				// Find the distribution for current section
				const currentSectionID = this.currentSection?.sectionID;
				if (currentSectionID) {
					return (
						this.currentSectionData.sectionInfo.answerDistribution.find(
							(dist) => dist.sectionID === currentSectionID
						) || this.currentSectionData.sectionInfo.answerDistribution[0]
					);
				}
				return this.currentSectionData.sectionInfo.answerDistribution[0];
			}
			return null;
		},
		// Helper computed properties for section type checks
		isCodingSection() {
			return this.currentSection && this.currentSection.codingSection === true;
		},
		isCommunicationSection() {
			return (
				this.currentSection && this.currentSection.communicationSection === true
			);
		},
		isRegularSection() {
			return (
				this.currentSection &&
				!this.currentSection.codingSection &&
				!this.currentSection.communicationSection
			);
		},
		// Communication section data
		communicationSectionInfo() {
			if (this.currentSectionData && this.currentSectionData.sectionInfo) {
				return this.currentSectionData.sectionInfo;
			}
			return null;
		},
		overallCommunicationScore() {
			if (
				this.communicationSectionInfo &&
				this.communicationSectionInfo.overallCommunicationSectionScore
			) {
				return this.communicationSectionInfo.overallCommunicationSectionScore;
			}
			return null;
		},

		overallFeedbacks() {
			if (
				this.communicationSectionInfo &&
				this.communicationSectionInfo.overallFeedbacks
			) {
				return this.communicationSectionInfo.overallFeedbacks;
			}
			return null;
		},
		sectionResponse() {
			if (
				this.communicationSectionInfo &&
				this.communicationSectionInfo.sectionResponse
			) {
				return this.communicationSectionInfo.sectionResponse;
			}
			return [];
		},
		// Calculate overall score for display
		calculatedOverallScore() {
			if (!this.overallCommunicationScore)
				return { score: 0, outOf: 2, percentage: 0 };
			const scores = this.overallCommunicationScore;
			const total =
				(scores.pronunciationScore?.score || 0) +
				(scores.fluencyScore?.score || 0) +
				(scores.vocabularyScore?.score || 0) +
				(scores.grammarScore?.score || 0) +
				(scores.relatableScore?.score || 0);
			const outOf = scores.outOf || 2;
			const maxTotal = outOf * 5; // 5 metrics
			const percentage = maxTotal > 0 ? (total / maxTotal) * 100 : 0;
			return { score: total, outOf: maxTotal, percentage: percentage };
		},
		// Get overall score message
		overallScoreMessage() {
			const percentage = this.calculatedOverallScore.percentage;
			if (percentage >= 80) return "Excellent Communication Skills!";
			if (percentage >= 65) return "Great Communication Skills!";
			if (percentage >= 50) return "Good Communication Skills!";
			if (percentage >= 35) return "Fair Communication Skills";
			return "Needs Improvement";
		},
		// Child sections computed properties
		childSections() {
			if (this.currentSection && this.currentSection.childSections) {
				return this.currentSection.childSections;
			}
			return [];
		},
		currentChildSectionData() {
			if (
				this.selectedChildSectionID &&
				this.sectionData[this.selectedChildSectionID]
			) {
				return this.sectionData[this.selectedChildSectionID];
			}
			return null;
		},
		childSectionQuestions() {
			if (
				this.currentChildSectionData &&
				this.currentChildSectionData.sectionInfo &&
				this.currentChildSectionData.sectionInfo.sectionResponse
			) {
				return this.currentChildSectionData.sectionInfo.sectionResponse;
			}
			return [];
		},
	},
	created() {
		this.getAssessmentReport();
	},
	mounted() {
		if (this.scrollContainerRef) {
			this.initScroll();
		}
	},
	filters: {
		convertSecToMin(time) {
			return !time
				? "--"
				: time < 60
				? time + "sec"
				: (time / 60).toFixed(2) + "min";
		},
		formatDateTime(date) {
			const parsedDate = new Date(date);
			const day = parsedDate.getDate();
			const month = parsedDate.toLocaleString("default", { month: "long" });
			const year = parsedDate.getFullYear();

			const hours = parsedDate.getHours();
			const minutes = parsedDate.getMinutes().toString().padStart(2, "0");
			const ampm = hours >= 12 ? "PM" : "AM";
			const twelveHour = hours % 12 || 12;

			return `${day} ${month} ${year}, ${twelveHour
				.toString()
				.padStart(2, "0")}:${minutes} ${ampm}`;
		},
	},
	methods: {
		gobckMobile() {
			this.$router.push({
				path: "/assessment/progress",
				query: {
					...this.$route.query,
					screen: "mobile-view-marks",
				},
			});
		},
		getPerformanceScroll(key) {
			const ref = this.$refs["performancescroll_" + key];
			if (!ref) return null;
			return Array.isArray(ref) ? ref[0] : ref;
		},
		getOverallGradeClass(grade) {
			const baseClass = "overall-tag-g";
			if (!grade) return baseClass;

			const gradeLower = grade.toLowerCase();

			if (
				gradeLower.includes("great") ||
				gradeLower.includes("excellent") ||
				gradeLower.includes("pass")
			) {
				return `${baseClass} bg-green`;
			}
			if (gradeLower.includes("good") || gradeLower.includes("average")) {
				return `${baseClass} bg-yellow`;
			}
			if (gradeLower.includes("fair") || gradeLower.includes("okay")) {
				return `${baseClass} bg-orange`;
			}
			if (
				gradeLower.includes("poor") ||
				gradeLower.includes("needs improvement") ||
				gradeLower.includes("fail")
			) {
				return `${baseClass} bg-red`;
			}

			return baseClass;
		},
		formatDateTime2(attempt) {
			if (!attempt) return "--";

			// Force UTC by appending Z
			const iso = attempt.includes(" ")
				? attempt.replace(" ", "T") + "Z"
				: attempt;

			const date = new Date(iso); // browser converts to local time (IST)

			if (isNaN(date)) return "--";

			const day = date.getDate();
			const month = date.toLocaleString("en-IN", { month: "long" });
			const year = date.getFullYear();

			const hours = date.getHours();
			const minutes = date.getMinutes().toString().padStart(2, "0");
			const ampm = hours >= 12 ? "PM" : "AM";
			const twelveHour = hours % 12 || 12;

			return `${day} ${month} ${year}, ${twelveHour
				.toString()
				.padStart(2, "0")}:${minutes} ${ampm}`;
		},
		formatSectionMarks(value) {
			const num = Number(value);
			if (Number.isInteger(num)) {
				return num.toString();
			}
			return num.toFixed(1);
		},
		isCommunicationNotAttempted() {
			if (!this.communicationSectionInfo?.communicationSection) return false;

			if (Number(this.communicationSectionInfo.sectionMarks) !== 0)
				return false;

			if (!Array.isArray(this.sectionResponse)) return false;

			return this.sectionResponse.every(
				(q) => q.answerStatus?.attempted === false
			);
		},
		formatScore(value) {
			if (value === null || value === undefined) return "--";

			// If decimal → show 2 digits, else show as is
			return Number.isInteger(value) ? value : value.toFixed(2);
		},
		toggleMobileSkill(key) {
			if (!this.isMobile) return;
			this.$set(this.mobileSkillCollapse, key, !this.mobileSkillCollapse[key]);
		},
		getApiSectionID(section) {
			if (section?.codingSection === true) {
				return "PROGRAMMINGSECTION";
			}
			return section.sectionID;
		},
		toggleDifficultySort(column) {
			if (this.difficultySortColumn !== column) {
				this.difficultySortColumn = column;
				this.difficultySortOrder = "desc";
			} else {
				this.difficultySortOrder =
					this.difficultySortOrder === "desc" ? "asc" : "desc";
			}

			this.expandedDifficultyLevels = {};
		},
		toggleMarksSort(column) {
			if (this.marksSortColumn !== column) {
				this.marksSortColumn = column;
				this.marksSortOrder = "desc";
			} else {
				this.marksSortOrder = this.marksSortOrder === "desc" ? "asc" : "desc";
			}

			this.expandedMarksLevels = {};
		},

		async getAssessmentReport(sectionID = null) {
			try {
				this.loadingSection = true;
				let payload = {
					testID: this.$route.query.testID,
					groupID: this.$route.query.groupID,
					attemptNo: this.$route.query.attemptNo,
				};
				// Add sectionID to payload if provided
				if (sectionID) {
					payload.sectionID = sectionID;
				}

				const res = await getAssessmentReport(payload);
				if (res.status == 200) {
					if (sectionID) {
						// Store section-specific data
						this.$set(this.sectionData, sectionID, res.data.data);
						// If section response includes candidateData with aiSummary and main report doesn't have it,
						// preserve it in assessmentReport for currentAiSummary to access
						if (res.data.data?.candidateData?.stats?.aiSummary) {
							// Ensure assessmentReport exists
							if (!this.assessmentReport) {
								this.assessmentReport = {};
							}
							// Ensure nested structure exists
							if (!this.assessmentReport.candidateData) {
								this.$set(this.assessmentReport, "candidateData", {});
							}
							if (!this.assessmentReport.candidateData.stats) {
								this.$set(this.assessmentReport.candidateData, "stats", {});
							}
							// Only set aiSummary if it doesn't exist or if section response has it
							if (!this.assessmentReport.candidateData.stats.aiSummary) {
								this.$set(
									this.assessmentReport.candidateData.stats,
									"aiSummary",
									res.data.data.candidateData.stats.aiSummary
								);
							}
						}
						// Initialize expanded states for first items
						this.$nextTick(() => {
							const sectionInfo = res.data.data?.sectionInfo;
							console.log(sectionInfo, "hellooo");

							if (sectionInfo) {
								if (sectionInfo.codingSectionData) {
									sectionInfo.codingSectionData.forEach((item) => {
										// Wrap item in sectionInfo to match expected structure for child sections
										this.$set(this.sectionData, item.sectionID, {
											sectionInfo: item,
										});
									});
								} else {
									if (
										sectionInfo.byDifficulty &&
										sectionInfo.byDifficulty.length > 0
									) {
										const firstDifficulty =
											sectionInfo.byDifficulty[0].difficultyLevel;
										if (sectionInfo.byDifficulty) {
											this.originalByDifficultyData = [
												...sectionInfo.byDifficulty,
											];
										}
										if (!this.expandedDifficultyLevels[firstDifficulty]) {
											this.$set(
												this.expandedDifficultyLevels,
												firstDifficulty,
												true
											);
										}
									}
									if (sectionInfo.byMarks && sectionInfo.byMarks.length > 0) {
										const firstMark =
											sectionInfo.byMarks[0].marksOfeachQuestion;
										if (!this.expandedMarksLevels[firstMark]) {
											this.$set(this.expandedMarksLevels, firstMark, true);
										}
									}
								}
							}
						});
					} else {
						// Initial load - store main assessment report
						// Direct assignment should work since assessmentReport is a data property
						this.assessmentReport = res.data.data;

						// Wait for Vue to process the change and update computed properties
						// This ensures sections, currentSection, and currentAiSummary are updated
						await this.$nextTick();

						// Verify data structure is correct
						if (!this.assessmentReport?.candidateData?.stats?.aiSummary) {
							console.warn("AI Summary not found in initial response");
						}

						// Load first section data by default
						if (this.sections.length > 0) {
							await this.selectSection(0);
						}
						// Wait for section data to be processed and UI to update
						await this.$nextTick();
					}
				}
			} catch (error) {
				console.log(error);
			} finally {
				this.loadingSection = false;
			}
		},
		async selectSection(index) {
			this.selectedSectionIndex = index;
			this.selectedChildSectionID = null; // Reset child section
			const section = this.sections[index];
			if (section) {
				const apiSectionID = this.getApiSectionID(section);

				if (!this.sectionData[section.sectionID]) {
					await this.getAssessmentReport(apiSectionID);
				}
				console.log(section, "tis is the section log");

				// If section has child sections, select first one by default
				if (section.childSections && section.childSections.length > 0) {
					const firstChildSection = section.childSections[0];
					if (firstChildSection.sectionID) {
						await this.selectChildSection(firstChildSection.sectionID);
					}
				}
				// Initialize expanded states for first items
				this.$nextTick(() => {
					if (
						this.byDifficultyData.length > 0 &&
						!this.expandedDifficultyLevels[
							this.byDifficultyData[0].difficultyLevel
						]
					) {
						this.$set(
							this.expandedDifficultyLevels,
							this.byDifficultyData[0].difficultyLevel,
							true
						);
					}
					if (
						this.byMarksData.length > 0 &&
						!this.expandedMarksLevels[this.byMarksData[0].marksOfeachQuestion]
					) {
						this.$set(
							this.expandedMarksLevels,
							this.byMarksData[0].marksOfeachQuestion,
							true
						);
					}
				});
			}
		},
		async selectChildSection(childSectionID) {
			this.selectedChildSectionID = childSectionID;
			// Only fetch if we don't already have the data
			if (!this.sectionData[childSectionID]) {
				await this.getAssessmentReport(childSectionID);
			}
		},
		toggleQuestionCollapse(questionKey) {
			const isCurrentlyOpen = this.collapseQuestion[questionKey];
			this.collapseQuestion = {};

			if (!isCurrentlyOpen) {
				this.$set(this.collapseQuestion, questionKey, true);

				this.$nextTick(() => {
					// force slider init after DOM appears
					const el = this.getPerformanceScroll(questionKey);
					if (el) {
						this.$forceUpdate();
					}
				});
			}
		},
		stripHtml(html) {
			if (!html) return "";
			const tmp = document.createElement("DIV");
			tmp.innerHTML = html;
			return tmp.textContent || tmp.innerText || "";
		},
		toggleDifficultyLevel(level) {
			const isOpen = this.expandedDifficultyLevels[level];

			// close all
			this.expandedDifficultyLevels = {};

			// open only if it was closed
			if (!isOpen) {
				this.$set(this.expandedDifficultyLevels, level, true);
			}
		},

		toggleMarksLevel(level) {
			const isOpen = this.expandedMarksLevels[level];

			// close all
			this.expandedMarksLevels = {};

			// open only if it was closed
			if (!isOpen) {
				this.$set(this.expandedMarksLevels, level, true);
			}
		},

		// Helper methods for communication section
		formatDuration(seconds) {
			if (!seconds) return "0:00 Hrs";
			const hours = Math.floor(seconds / 3600);
			const minutes = Math.floor((seconds % 3600) / 60);
			const secs = seconds % 60;
			if (hours > 0) {
				return `${hours}:${minutes.toString().padStart(2, "0")} Hrs`;
			}
			return `${minutes}:${secs.toString().padStart(2, "0")} Hrs`;
		},
		formatDurationShort(seconds) {
			if (!seconds) return "0s";
			const minutes = Math.floor(seconds / 60);
			const secs = seconds % 60;
			if (minutes > 0) {
				return `${minutes}m ${secs}s`;
			}
			return `${secs}s`;
		},
		formatTimePerQuestion() {
			if (
				!this.communicationSectionInfo ||
				!this.sectionResponse ||
				this.sectionResponse.length === 0
			) {
				return "0 m 0 sec";
			}
			const totalDuration =
				this.communicationSectionInfo.totalDurationInSec || 0;
			const questionCount = this.sectionResponse.length;
			const avgSeconds = Math.floor(totalDuration / questionCount);
			const minutes = Math.floor(avgSeconds / 60);
			const seconds = avgSeconds % 60;
			if (minutes > 0) {
				return `${minutes} m ${seconds} sec`;
			}
			return `${seconds} sec`;
		},
		getProgressPercentage(score, outOf) {
			if (!score || !outOf || outOf === 0) return 0;
			return Math.round((score / outOf) * 100);
		},
		getScoreColor(score) {
			if (score <= 0.5) return "color-red-progress";
			if (score <= 1) return "color-yellow-progress";
			if (score <= 1.5) return "color-orange-progress";
			return "color-green-progress";
		},
		getProgressVariant(color) {
			if (!color) return "success";
			const colorMap = {
				green: "success",
				yellow: "info",
				orange: "warning", // Will be overridden by orange class
				red: "danger",
			};
			return colorMap[color.toLowerCase()] || "success";
		},
		getSkillScoreColor(color) {
			if (!color) return "text-green";
			const colorMap = {
				green: "text-green",
				yellow: "text-EAB308",
				orange: "text-FB923C ",
				red: "text-red",
			};
			return colorMap[color.toLowerCase()] || "text-464667";
		},
		renderAnswerDistributionGraph() {
			if (!this.answerDistribution) return;

			const dist = this.answerDistribution;

			const formattedData = [
				{
					label: "Correct Answers",
					value: dist.numberOfCorrectAnswers || 0,
					percent: dist.correctPercentage || 0,
				},
				{
					label: "Incorrect Answers",
					value: dist.numberOfIncorrectAnswers || 0,
					percent: dist.incorrectPercentage || 0,
				},
				{
					label: "Not Answered",
					value: dist.numberOfNotAttempted || 0,
					percent: dist.notAnsweredPercentage || 0,
				},
			];

			this.donutGraph.draw(
				"answer-distribution-chart",
				formattedData,
				this.isMobile,
				this.showAnswerPercentage
			);
		},
		getCommunicationText(section) {
			const total = section.serctionTotalMarks;
			const marks = Number(section.sectionMarks);

			if (
				section.communicationSection === true &&
				marks === 0 &&
				Array.isArray(section.sectionResponse) &&
				section.sectionResponse.every(
					(q) => q.answerStatus && q.answerStatus.attempted === false
				)
			) {
				return "No results available";
			}

			if (marks <= total / 4) return "Fair Communication Skills!";
			if (marks <= (total / 4) * 2) return "Okay Communication Skills";
			if (marks <= (total / 4) * 3) return "Good Communication Skills";
			return "Great Communication Skills!";
		},
	},
	watch: {
		scrollContainerRef(val) {
			if (val) {
				this.initScroll();
			}
		},
		showAnswerPercentage() {
			this.$nextTick(() => {
				this.renderAnswerDistributionGraph();
			});
		},
		currentSectionData: {
			handler() {
				this.$nextTick(() => {
					if (this.isRegularSection) {
						this.renderAnswerDistributionGraph();
					}
				});
			},
			deep: true,
		},
	},
	components: {
		HorizontalSliderBlog,
	},
};
</script>

<style lang="scss">
.mob-flex-3 {
	display: flex;
	align-items: center;
}
.assess-report-maincont {
	position: relative;
	background: var(--bg-lightblueback);
	height: calc(100vh - 60px);
	top: 60px;
	padding: 15px 15px 15px 75px;
}
.header-bak {
	background: #20639b14;
}
.assrep-below-header {
	background: #fafafa;
	border-radius: 8px;
	margin-top: 8px;
	height: calc(100vh - 150px);
	overflow: auto;
}
.assrep-below-header {
	.info-section {
		padding: 15px;
		border-bottom: 1px solid #8c8c8c4d;
	}
	.dp {
		background-color: red;
		border-radius: 50%;
		width: 100px;
		height: 100px;
		flex-shrink: 0;
	}
	.tabs-section {
		background-color: #f7f9fc;
		display: flex;
		padding: 16px 0 16px 24px;
		width: 100%;
		overflow-x: auto;
		z-index: 3;
	}
	.coding-sticky {
		position: sticky;
		top: 0;
	}
	.tabs-section::-webkit-scrollbar {
		scroll-behavior: smooth !important;
		width: 0px !important;
		height: 0px !important;
		background-color: transparent !important;
	}
	.tabs-section-2 {
		position: sticky;
		top: 60px;
		background-color: #fafafa;
		padding-block: 15px 10px;
		width: 100%;
		overflow-x: auto;
		padding-left: 10px;
	}
	.tabs-section article,
	.tabs-section-2 article {
		border: 1px solid #20639b;
		border-radius: 25px;
		font-family: "Montserrat", sans-serif;
		font-weight: 400;
		font-size: 14px;
		color: #2e425d;
		padding: 4px 16px;
		white-space: nowrap;
		margin-right: 15px;
	}
	.tabs-section article.selected,
	.tabs-section-2 article.selected {
		background-color: #20639b;
		color: #fff;
		font-weight: 600;
	}
	.summary-box {
		background: linear-gradient(282.02deg, #20639b 32.16%, #154b74 67.84%);
		border-radius: 8px;
		padding: 16px;
	}
	.overall-tag-g {
		background-color: #269c32;
		border-radius: 25px;
		padding: 4px;
		width: 122px;
		display: flex;
		justify-content: center;
	}
	.summary-box .one {
		padding-bottom: 15px;
		border-bottom: 2px dashed #e0e0e038;
	}
	.strength {
		background-color: #f0fdf4;
		padding: 16px;
		border-radius: 8px;
		width: calc((100% - 32px) / 3);
	}
	.weakness {
		background-color: #f3f6ff;
		padding: 16px;
		border-radius: 8px;
		width: calc((100% - 32px) / 3);
	}

	.clarification {
		background-color: #fff6ed;
		padding: 16px;
		border-radius: 8px;
		width: calc((100% - 32px) / 3);
	}
	.dashed-div-2 {
		border-bottom: 2px dashed #72738e3b;
		height: 15px;
		margin-bottom: 10px;
	}
	.lined-div {
		border-bottom: 2px solid #72738e3b;
		height: 15px;
		margin-bottom: 10px;
	}
	.line {
		flex: 1;
		height: 1px;
		background-color: #8c8c8c54;
	}
	.graph-container {
		border: 1px solid #e5e5e5;
		background-color: #fff;
		border-radius: 8px;
		padding: 16px;
		margin-top: 15px;
	}
	.flex-box-1 {
		display: flex;

		gap: 15px;
	}
	.border-box-1 {
		border: 1px solid #8c8c8c4d;
		background-color: #fafafa;
		padding: 16px;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.calc-wid {
		width: calc((100% - 32px) / 3);
	}
	.summary-h-width {
		width: 120px;
	}
	.vert-line {
		width: 1px;
		height: 16px;
		background-color: #8c8c8c54;
	}
	.performance-table .head {
		background-color: #e9f0f5;
		font-family: "Lato", sans-serif;
		font-weight: 600;
		font-size: 14px;
		color: #20639b;
		display: flex;
		align-items: center;
		padding: 10px 10px 10px 40px;
	}
	.performance-table .body {
		max-height: 200px;
		overflow: auto;
		padding: 3px;
	}
	.performance-table .body article {
		background-color: #fcfcfc;
		box-shadow: 0px 4px 15px 0px #c4c4c480;
		border-radius: 5px;
		padding: 10px 10px 10px 40px;
		display: flex;
		align-items: center;
		position: relative;
	}
	.performance-table .body article span {
		background-color: #e9f0f5;
		border-radius: 4px;
		padding: 2px 6px;
	}
	.performance-table .body article .blue-bar {
		width: 3px;
		height: 92%;
		background-color: #20639b;
		border-radius: 4px;
		position: absolute;
		left: 3px;
	}
	.attention-box {
		border-radius: 8px;
		padding: 6px;
	}
	.green-box {
		border-radius: 6px;
		padding: 10px 16px;
		display: flex;
		align-items: center;
	}
	.candash-player .orange .progress-bar {
		background-color: #fb923c;
	}
	.candash-player .progress,
	.candash-player .progress-bar {
		box-shadow: unset;
	}
	.comuni-tabs {
		border: 1px solid #e5e5e5;
		border-radius: 25px;
		padding: 8px 16px;
	}
	.dashed-div-3 {
		border-left: 2px dashed #72738e3b;
		padding-left: 20px;
	}
	.green-marks {
		background: #038e001a;
		border-radius: 25px;
		padding: 5px 10px;
		white-space: nowrap;
		width: 70px;
		display: flex;
		justify-content: center;
	}
	.question-card {
		box-shadow: 0px 0px 20px 0px #56565621;
		border-radius: 8px;
		background-color: #fff;
		padding: 16px;
	}
	.performance-box {
		border: 1px solid #20639b1a;
		background: #20639b0a;
		border-radius: 10px;
		padding: 16px;
	}
	.arrow-icon {
		height: 32px;
		width: 32px;
	}
	.cursor-pointer {
		cursor: pointer;
	}
	/* Rep-1 Optimized Styles */
	.stats-grid {
		display: flex;
		gap: 15px;
	}
	.attention-box {
		display: flex;
		gap: 15px;
		align-items: flex-start;
	}
	.attention-content {
		flex: 1;
	}
	.candash-player {
		margin-top: 15px;
	}
	.skill-item {
		margin-top: 15px;
	}
	.skill-item:first-child {
		margin-top: 0;
	}
	.skill-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 8px;
	}
	.skill-score {
		font-weight: 500;
	}
	.skill-progress {
		height: 8px;
	}
	.detailed-summary-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 15px;
		flex-wrap: wrap;
		gap: 15px;
	}
	.summary-tabs {
		display: flex;
		gap: 10px;
		flex-wrap: wrap;
	}
	.detailed-summary-item {
		display: flex;
		align-items: center;
		gap: 15px;
		margin-top: 15px;
		flex-wrap: wrap;
		border: 1px solid #e5e5e5;
		padding: 20px 10px;
		border-radius: 4px;
	}
	/* Rep-2 Optimized Styles */
	.rep-2-stats-container {
		display: flex;
		gap: 15px;
		margin-top: 15px;
	}
	.rep-2-stats-left {
		flex: 1;
		display: flex;
		flex-direction: column;
	}
	.rep-2-chart-container {
		flex: 1;
		min-height: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.chart-placeholder {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.chart-label {
		font-family: "Montserrat", sans-serif;
		font-weight: 500;
		font-size: 14px;
		color: #464667;
	}
	.total-questions-box {
		align-items: flex-start !important;
	}
	.total-questions-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-direction: column;
		width: 100%;
		gap: 20px;
	}
	.total-questions-left {
		flex-shrink: 0;
	}
	.question-breakdown-horizontal {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
		flex: 1;
		justify-content: flex-end;
	}
	.breakdown-label {
		font-style: italic;
	}
	.vert-line-breakdown {
		width: 1px;
		height: 16px;
		background-color: #8c8c8c54;
		margin: 0 4px;
	}
	.performance-table {
		overflow-x: auto;
	}
	.performance-table .head,
	.performance-table .body article {
		min-width: 600px;
	}
	/* Mobile Performance Cards */
	.desktop-only {
		display: block;
	}
	.mobile-only {
		display: none;
	}
	.performance-cards {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}
	.performance-card {
		background-color: #fff;
		border: 1px solid #e5e5e5;
		border-radius: 8px;
		overflow: hidden;
	}
	.performance-card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
		cursor: pointer;
	}
	.card-title-section {
		display: flex;
		align-items: center;
		gap: 10px;
	}
	.level-badge {
		background-color: #e9f0f5;
		border-radius: 4px;
		padding: 4px 8px;
		font-family: "Montserrat", sans-serif;
		font-weight: 500;
		font-size: 14px;
		color: #20639b;
		min-width: 28px;
		text-align: center;
	}
	.card-accuracy-section {
		display: flex;
		align-items: center;
		gap: 8px;
	}
	.arrow-icon-small {
		height: 20px;
		width: 20px;
		transition: transform 0.3s ease;
	}
	.rotated-90 {
		transform: rotate(90deg);
	}
	.performance-card-content {
		padding: 12px 16px 16px 40px;
		border-top: 1px solid #e5e5e5;
		background-color: #fafafa;
	}
	.performance-detail-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}
	.performance-detail-item:last-child {
		margin-bottom: 0;
	}
}
.text-434F5E {
	color: #434f5e;
}
@media (max-width: 1028px) {
	.assrep-below-header .arrow-icon {
		height: 16px;
		width: 16px;
	}
	.mob-italic {
		font-style: italic;
	}
	.align-items-unset {
		align-items: unset !important;
	}
	.mobile-flex-row {
		display: flex !important;
		align-items: baseline !important;
		justify-content: space-between !important;
		flex-direction: row !important;
	}
	.assess-report-maincont {
		height: 100dvh;
		top: 0;
		padding: unset;
	}
	.assrep-below-header {
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		margin-top: unset;
	}
	.assrep-below-header {
		.dp {
			width: 50px;
			height: 50px;
		}
		.summary-box .one {
			align-items: flex-start !important;
			gap: 16px;
		}
		.ques-hor-scroll {
			width: 100%;
			overflow-x: auto;
		}
		.strength,
		.weakness,
		.clarification {
			width: 245px;
			flex-shrink: 0;
		}
		.assessment-report-slider-parent .slider {
			background: #f0f0f54d;
		}
		.assessment-report-slider-parent .slider::-webkit-slider-thumb {
			background: #fff;
		}
		.back-color {
			background-color: #e9ecef;
		}
		/* Rep-1 Mobile Styles */
		.stats-grid {
			flex-direction: column;
			gap: 10px;
		}
		.border-box-1 {
			width: 100%;
			align-items: flex-start;
		}
		.attention-box {
			flex-direction: column;
			gap: 12px;
		}
		.green-box {
			width: 100%;
			justify-content: center;
		}
		.skill-header {
			align-items: flex-start;
			gap: 5px;
		}
		.detailed-summary-header {
			flex-direction: column;
			align-items: flex-start;
		}
		.summary-tabs {
			width: 100%;
			overflow-x: auto;
			flex-wrap: unset;
		}
		.comuni-tabs {
			justify-content: center;
			white-space: nowrap;
		}
		.detailed-summary-item {
			flex-direction: column;
			align-items: flex-start;
			gap: 10px;
			padding: 10px;
		}
		.dashed-div-3 {
			border-left: none;
			border-top: 2px dashed #72738e3b;
			padding-left: 0;
			padding-top: 10px;
			width: 100%;
		}
		/* Rep-2 Mobile Styles */
		.rep-2-stats-container {
			flex-direction: column;
			gap: 10px;
		}
		.rep-2-stats-left {
			width: 100%;
		}
		.rep-2-chart-container {
			width: 100%;
			min-height: 150px;
		}
		.total-questions-wrapper {
			flex-direction: column;
			align-items: flex-start;
			gap: 15px;
		}
		.total-questions-left {
			flex-shrink: unset;
		}
		.question-breakdown-horizontal {
			gap: 4px;
			justify-content: flex-end;
			align-items: end;
			margin-top: 0;
			flex-direction: column;
		}
		.vert-line-breakdown {
			display: none;
			height: 14px;
			margin: 0 2px;
		}
		.performance-table .head,
		.performance-table .body article {
			min-width: unset;
		}
		.performance-table .head {
			flex-wrap: wrap;
			padding: 10px;
		}
		.performance-table .head > div {
			font-size: 12px;
			padding: 5px;
		}
		.performance-table .body article {
			flex-wrap: wrap;
			padding: 10px;
		}
		.performance-table .body article > div {
			font-size: 12px;
			padding: 5px;
		}
		/* Show mobile cards, hide desktop table */
		.desktop-only {
			display: none !important;
		}
		.mobile-only {
			display: block !important;
		}
		.performance-card-header {
			flex-wrap: wrap;
			gap: 10px;
		}
		.card-title-section {
			flex: 1;
			min-width: 120px;
		}
		.card-accuracy-section {
			flex-shrink: 0;
		}
		.performance-card-content {
			padding-left: 16px;
		}
		.graph-container {
			padding: 12px;
		}
		.mob-flex-3 {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
		}
		.mob-flex-4 {
			flex-direction: column;
			align-items: flex-start !important;
		}
		.mob-hor-scroll-1 {
			width: 100%;
			overflow-x: auto;
		}
		.mob-flex-5 {
			flex-direction: column;
		}
		.mob-hor-scroll-1 .performance-box {
			min-width: 240px;
		}
		.mob-flex-5 .performance-box {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		.mob-flex-5 .mt-3 {
			margin-top: 0 !important;
		}
	}
}
.percent-count-switch {
	position: relative;
	width: 95px;
	height: 44px;
	cursor: pointer;
	user-select: none;
}

.switch-track {
	background: #ffffff;
	border-radius: 30px;
	box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
	height: 100%;
	display: flex;
	align-items: center;
	padding: 4px;
	position: relative;
}

/* BLUE KNOB */
.switch-knob {
	width: 36px;
	height: 36px;
	border-radius: 50%;
	background: #20639b;
	transition: transform 0.3s ease;
}

/* MOVE KNOB TO % SIDE */
.percent-count-switch.active .switch-knob {
	transform: translateX(44px);
}

/* ICONS */
.switch-icons {
	position: absolute;
	top: 50%;
	left: 0;
	width: 100%;
	display: flex;
	justify-content: space-between;
	padding: 0 16px;
	transform: translateY(-50%);
	font-weight: 600;
	color: #20639b;
	pointer-events: none;
}

/* RESET BOTH */
.switch-icons span {
	transition: opacity 0.2s ease;
}

.switch-icons span.selected {
	color: #fff;
	font-weight: 700;
}
.knob-text {
	color: #ffffff;
	font-size: 14px;
	font-weight: 600;
	transition: font-weight 0.2s ease;
}

/* WHEN % IS ACTIVE */
.knob-text.active {
	font-weight: 700;
	z-index: 1;
}

/* Shimmer Loading Styles */
.shimmer-container {
	position: relative;
	overflow: hidden;
}

.shimmer-container::before {
	content: "";
	position: absolute;
	top: 0;
	left: -100%;
	width: 100%;
	height: 100%;
	background: linear-gradient(
		90deg,
		transparent,
		rgba(255, 255, 255, 0.2),
		transparent
	);
	animation: shimmer 1.5s infinite;
}

.shimmer-card {
	position: relative;
	overflow: hidden;
}

.shimmer-card::before {
	content: "";
	position: absolute;
	top: 0;
	left: -100%;
	width: 100%;
	height: 100%;
	background: linear-gradient(
		90deg,
		transparent,
		rgba(255, 255, 255, 0.3),
		transparent
	);
	animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
	0% {
		left: -100%;
	}
	100% {
		left: 100%;
	}
}

.shimmer-container .b-skeleton,
.shimmer-card .b-skeleton {
	animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.6;
	}
}

.bg-matte-green {
	background-color: #eef7ef !important;
}
.bg-matte-red {
	background-color: #fcddc8;
}
.bg-matte-orange {
	background-color: #fee9d8;
}
.bg-matte-yellow {
	background-color: #fff0c6;
}
.bg-matte-7a7a7a {
	background: #f1f1f4;
}
.bg-green {
	background-color: #269c32;
}
.bg-yellow {
	background-color: #eab308;
}
.bg-orange {
	background-color: #fb923c;
}
.bg-red {
	background-color: #ad1927;
}
.border-green {
	border: 1px solid #269c32;
}
.border-yellow {
	border: 1px solid #eab308;
}
.border-orange {
	border: 1px solid #fb923c;
}
.border-red {
	border: 1px solid #ad1927;
}
.border-7a7a7a {
	border: 1px solid #7a7a7a;
}
.bg-grey {
	background-color: #ededf0;
}
.bg-7a7a7a {
	background: #7a7a7a;
}

.color-green-progress {
	color: #038e00;
}
.color-orange-progress {
	color: #fb923c;
}
.color-yellow-progress {
	color: #eab308;
}
.color-red-progress {
	color: #ad1927;
}
.rotated-275 {
	transform: rotate(275deg);
}

.bg-warning {
	background-color: #fb923c !important;
}
.bg-danger {
	background-color: #ad1927 !important;
}
.bg-success {
	background-color: #038e00 !important ;
}
.bg-info {
	background-color: #eab308 !important;
}
</style>
